export default "__VITE_ASSET__712dfeb0__"